import styled from "@emotion/styled";
import { FC } from "react";

import { Info } from "@livechat/design-system-icons";
import { DesignToken, Heading, IPickerListItem, Icon, Tooltip } from "@livechat/design-system-react-components";

import { ImportTicketsDateRangeSelect } from "components/ImportTicketsDateRangeSelect";
import { LiveChatDataImportType } from "routes/settings/integrations/constants";
import { withVar } from "themes/helpers";

import { ImportOptionCard } from "./ImportOptionCard";

interface IProps {
  selected: boolean;
  showUpdateSubscriptionDisclaimer: boolean;
  selectedDateRange: IPickerListItem | null;
  onDateRangeSelect: (dateRange: IPickerListItem) => void;
  onOptionClick: () => void;
}

export const ImportTicketsOptionCard: FC<IProps> = ({
  selected,
  onOptionClick,
  selectedDateRange,
  onDateRangeSelect,
  showUpdateSubscriptionDisclaimer,
}) => {
  return (
    <ImportOptionCard
      type={LiveChatDataImportType.Tickets}
      title="Import tickets from"
      onClick={onOptionClick}
      selected={selected}
      addons={
        <TicketAddons>
          <div
            onClick={e => {
              e.stopPropagation();
              e.preventDefault();
            }}
          >
            <ImportTicketsDateRangeSelect
              selectedDateRange={selectedDateRange}
              onDateRangeSelect={onDateRangeSelect}
              disabled={!selected}
            />
          </div>
          <StyledTooltip
            triggerRenderer={<Icon source={Info} customColor={withVar(DesignToken.ContentBasicPrimary)} />}
            placement="right"
            kind="invert"
          >
            <TooltipHeader size="xs">After importing the tickets:</TooltipHeader>
            <TicketsImportInfoList>
              <li>HelpDesk tickets will replace LiveChat tickets.</li>
              <li>Ticket form messages will be sent to HelpDesk.</li>
              <li>Emails forwarded to LiveChat will now be forwarded to HelpDesk.</li>
              <li>The General group in LiveChat, including all members, will become HelpDesk&apos;s default team.</li>
              {showUpdateSubscriptionDisclaimer && (
                <li>
                  Imported LiveChat users will keep their roles in HelpDesk and{" "}
                  <b>be billed per the chosen HelpDesk plan</b>.
                </li>
              )}
            </TicketsImportInfoList>
          </StyledTooltip>
        </TicketAddons>
      }
    />
  );
};

const TicketAddons = styled.div`
  flex-grow: 1;

  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const TicketsImportInfoList = styled.ul`
  list-style: disc;
  padding-left: 20px;
  font-size: 14px;
  line-height: 22px;
`;

const StyledTooltip = styled(Tooltip)`
  max-width: 250px;
`;

const TooltipHeader = styled(Heading)`
  padding-bottom: 4px;
`;
